import { AppContainer } from "@/components/layout/app-container";
import { SectionCard } from "@/components/ui/section-card";
import { SimpleAccordion } from "@/components/ui/simple-accordion";
import { useProjetoContext } from "@/context/projeto";

const formatBRL = (value: number | string) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
    Number(value) || 0
  );

export default function EstimatePage() {
  const { projetoSelecionado } = useProjetoContext();

  const activeBudget = projetoSelecionado?.budgets?.[0];
  const orcamentoPlanejado = activeBudget?.amount ?? 0;
  const orcamentoCaptado = activeBudget?.total_amount ?? 0;

  return (
    <AppContainer
      title="Orçamentos"
      description="Gerencie seus orçamentos de forma eficiente e prática."
    >
      <div className="grid grid-cols-2 gap-4">
        <SectionCard className="px-5 py-3">
          <SimpleAccordion
            className="bg-darkblue rounded-lg"
            itemClassName="border-none"
            defaultValue="0"
            items={[{
              id: '0',
              title: (
                <>
                  <h2 className="text-xs font-medium text-gray-300 whitespace-nowrap">
                    Desenvolvimento do Projeto
                  </h2>
                  <hr className="flex-1 mx-2 border-gray-600" />
                </>
              ),
              content: <div>Componente 1</div>
            }]}
          />
        </SectionCard>

        <div className="col-span-6 flex flex-col gap-4">
          {/* Budget summary card */}
          <SectionCard className="px-5 py-4">
            <div className="grid grid-cols-2 gap-4">
              {/* Planned budget */}
              <div className="flex flex-col gap-1 bg-white/5 rounded-lg px-4 py-3 border border-white/10">
                <span className="text-xs text-gray-400 font-medium">Orçamento Planejado</span>
                <span className="text-xl font-bold text-white tracking-tight">
                  {formatBRL(orcamentoPlanejado)}
                </span>
              </div>

              {/* Raised budget */}
              <div className="flex flex-col gap-1 bg-white/5 rounded-lg px-4 py-3 border border-white/10">
                <span className="text-xs text-gray-400 font-medium">Orçamento Captado</span>
                <span className="text-xl font-bold text-emerald-400 tracking-tight">
                  {formatBRL(orcamentoCaptado)}
                </span>
              </div>
            </div>
          </SectionCard>

          {/* Project overview card */}
          <SectionCard className="px-5 py-3">
            <h1>
              Visão Geral dos Projetos
            </h1>
          </SectionCard>
        </div>
      </div>
    </AppContainer>
  );
}